<template>
  <div class="done">
    <div class="inner">
      <img src="/images/done.svg" alt="Done" class="img" />
      <h2 class="title" v-html="texts.title"></h2>
      <p class="text" v-html="texts.text"></p>
      <NuxtLink to="/list" class="btn cta-gradient" v-html="texts.button">
      </NuxtLink>
    </div>
  </div>
</template>

<script setup>
const textsStore = useTextsStore()
const texts = computed(() => {
  return textsStore.deploy.success
})
</script>

<style lang="scss" scoped>
.done {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--Page-bg, #0e0e0e);
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inner {
  max-width: 460px;
  width: 100%;
  margin-inline: auto;
  text-align: center;

  .img {
    display: inline-block;
  }
}

.title {
  font-size: 3rem;
  font-weight: 500;
  margin-bottom: 15px;
}

.text {
  font-size: 1.7rem;
  opacity: 0.8;
  line-height: 150%;
  margin-bottom: 30px;
}
</style>
